module.exports = __webpack_public_path__ + "static/media/website.9f93c81c.png";